import classNames from 'classnames';
import { renderButtonContent } from 'components/Button/renderButtonContent';
import { forwardRef } from 'react';
import './Button.css';
import { Link, type LinkProps } from 'react-router-dom';
import type { ButtonProps } from './Button';
import { getButtonClassNames } from './getButtonClassNames';

type Props = Omit<ButtonProps, 'type'> & LinkProps;

export const ButtonLink = forwardRef<HTMLAnchorElement, Props>(
  (
    {
      accent,
      children,
      className,
      icon,
      iconStyle,
      iconPosition,
      loading,
      size,
      to,
      variant,
      dataTestId,
      ...restProps
    },
    ref,
  ) => (
    <Link
      className={getButtonClassNames(
        children,
        variant,
        classNames(className, 'align-middle', 'inline-block', 'text-center'),
        accent,
        size,
      )}
      ref={ref}
      to={to}
      data-testid={dataTestId}
      {...restProps}
    >
      {renderButtonContent({
        children,
        icon,
        iconStyle,
        iconPosition,
        loading,
        size,
      })}
    </Link>
  ),
);

ButtonLink.displayName = 'ButtonLink';
